<div class="container default-container results memnberTab office-block">
    <!-- Pagination mobile -->
    <paging [len]="len"
    [page]="page" 
    [config]="config" 
    [totalItems]="totalItems"                
    (changePage)="handleOnChangePage($event)" 
    (totalPage)="onTotalPage($event)"              
    (changeLen)="handleOnChangeSelectedValue($event)" 
    [turnOnTotalPage]="true"               
    [turnOnPagination]="false" 
    [turnOnTotalItem]="true" 
    [isMobile]="true">
   </paging>

    <div class="row mobile-block light mgb20">
        <div class="col-sm col-text">
            <p class="text-primary">※ 주문후 2일안에 결제가 이루어지지 않으면 자동 삭제됨을 유의해주시기 바랍니다.</p>
        </div>
    </div>
    
    <!-- table pc -->
    <div class="table-container row draggable-element">
        <div class="col col_data">
            <div class="table-wrapper table draggable-items-wrapper tb-scroll-container" draggableWrapper>
                <table class="hr-table" style="display: table">
                    <thead>
                        <tr>
                            <th class="sticky-col" style="white-space: nowrap; text-align: center;">구분</th>
                            <th style="white-space: nowrap; text-align: center;">공제번호</th>
                            <th style="white-space: nowrap; text-align: center;">주문번호</th>
                            <th style="white-space: nowrap; text-align: center;">주문일자</th>
                            <th style="white-space: nowrap; text-align: center;">승인일자</th>
                            <th style="white-space: nowrap; text-align: center;">주문유형</th>
                            <th style="white-space: nowrap; text-align: center;">센터</th>
                            <th style="white-space: nowrap; text-align: center;">회원번호</th>
                            <th style="white-space: nowrap; text-align: center;">회원명</th>
                            <th style="white-space: nowrap; text-align: center;">금액</th>
                            <th style="white-space: nowrap; text-align: center;" *ngIf="isPv1">{{ smWowWord.oPv1 }}</th>
                            <th style="white-space: nowrap; text-align: center;" *ngIf="isPv2">{{ smWowWord.oPv2 }}</th>
                            <th style="white-space: nowrap; text-align: center;" *ngIf="isPv3">{{ smWowWord.oPv3 }}</th>
                            <th style="white-space: nowrap; text-align: center;" *ngIf="isPoint">{{ smWowWord.oMileage
                                }}</th>
                            <th style="white-space: nowrap; text-align: center;">배송구분</th>
                            <th style="white-space: nowrap; text-align: center;">출고상태</th>
                            <th style="white-space: nowrap; text-align: center;">미결제액</th>
                            <th style="white-space: nowrap; text-align: center;">결제여부</th>
                            <th style="white-space: nowrap; text-align: center;">인쇄하기</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of collection | paginate: config">
                            <td class="sticky-col" style="text-align: center;">{{ item.status }}</td>
                            <td style="text-align: center;">{{ item.licenseNO }}</td>
                            <td style="text-align: center; cursor: pointer;" (click)="handleOnClickOrderNo(item.ordNo)">
                                {{ item.ordNo }}</td>
                            <td style="text-align: center;">{{ item.ordDate2 }}</td>
                            <td style="text-align: center;">{{ item.accDate2 }}</td>
                            <td>{{ item.kindName }}</td>
                            <td>{{ item.cntNameOrd }}</td>
                            <td style="text-align: center;">{{ item.userid }}</td>
                            <td>{{ item.username }}</td>
                            <td style="text-align: right;">{{ item.ordAmt | setComma }}원</td>
                            <td style="text-align: right;" *ngIf="isPv1">{{ item.ordPv1 | setComma }}</td>
                            <td style="text-align: right;" *ngIf="isPv2">{{ item.ordPv2 | setComma }}</td>
                            <td style="text-align: right;" *ngIf="isPv3">{{ item.ordPv3 | setComma }}</td>
                            <td style="text-align: right;" *ngIf="isPoint">{{ item.ordPoint | setComma }}</td>
                            <td>{{ item.deliKindName }}</td>
                            <td style="text-align: center;">{{ item.deliStatus }}</td>
                            <td style="text-align: right;">{{ item.rcptRemain | setComma }}</td>
                            <td style="text-align: center;">{{ item.rcptYN }}</td>
                            <td><a href="javascript:;" (click)="handleOnClickPrint(item);">인쇄하기</a></td>
                        </tr>
                    </tbody>
                    <ng-container *ngIf="totalRows < 5">
                        <tbody>
                            <tr *ngFor="let row of rows; index as i">
                                <ng-container *ngFor="let col of cols; index as j">
                                    <td style="width: 100%;">
                                        <span>&nbsp;</span>
                                        <ng-container *ngIf="totalRows === 0 && i === 2 && j === 8">
                                            <span class='h-small empty-warning'>조회된 데이타가 없습니다.</span>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </ng-container>
                    <tfoot>
                        <tr *ngIf="orderSumItem$ | async as item">
                            <td colspan="9" style="text-align: center;">[합계]</td>
                            <td style="text-align: right;">{{ item.ordAmt | setComma }}원</td>
                            <td style="text-align: right;" *ngIf="isPv1">{{ item.ordPv1 | setComma }}</td>
                            <td style="text-align: right;" *ngIf="isPv2">{{ item.ordPv2 | setComma }}</td>
                            <td style="text-align: right;" *ngIf="isPv3">{{ item.ordPv3 | setComma }}</td>
                            <td style="text-align: right;" *ngIf="isPoint">{{ item.ordPoint | setComma }}</td>
                            <td></td>
                            <td></td>
                            <td style="text-align: right;">{{ item.rcptRemain | setComma }}</td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
    <paging [len]="len"
    [page]="page" 
    [config]="config" 
    [totalItems]="totalItems"                
    (changePage)="handleOnChangePage($event)" 
    (totalPage)="onTotalPage($event)"              
    (changeLen)="handleOnChangeSelectedValue($event)" 
    [turnOnTotalPage]="true"               
    [turnOnPagination]="true" 
    [turnOnTotalItem]="true" 
    [isMobile]="false">
   </paging>
</div>